/**
 * Builder debug mode flag.
 *
 * Toggle at runtime via the browser console:
 *   localStorage.setItem('DEBUG_BUILDER', 'true')   // enable
 *   localStorage.removeItem('DEBUG_BUILDER')         // disable
 *
 * Then reload the page. When enabled:
 * - Curve paths render with a visible red stroke
 * - A text-metrics debug overlay appears at the bottom of the canvas
 */
export const isBuilderDebug = (): boolean =>
  typeof window !== 'undefined' && localStorage.getItem('DEBUG_BUILDER') === 'true';
